import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const studentBookList = createAsyncThunk(
  'school-student-book-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-book/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeStudentBook = createAsyncThunk(
  'school-student-book-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student-book/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const getStudentBookById = createAsyncThunk(
  'school-student-book-get',
  async (student_book_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-book/edit/` + student_book_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const viewStudentBook = createAsyncThunk(
  'school-student-book-view',
  async (student_book_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-book/view/` + student_book_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const printStudentBook = createAsyncThunk(
  'student-book-print',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-book/print/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type StudentBookState = {
  errors: any
}

const initialState: StudentBookState = {
  errors: '',
}

export const studentBookSlice = createSlice({
  name: 'student-book',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeStudentBook.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = studentBookSlice.actions
export default studentBookSlice.reducer
